import React, { createContext, useState } from 'react'

export enum AccountOpportunityFilter {
  ALL = 'all',
  OPEN = 'open',
  NONE = 'none'
}

export type AccountOpportunityFilterType = `${AccountOpportunityFilter}`

export interface AccountOpportunityContextValues {
  opportunities: AccountOpportunityFilterType
  setOpportunities: (opportunities: AccountOpportunityFilterType) => void
}
export const AccountOpportunityContext = createContext<AccountOpportunityContextValues>({
  opportunities: AccountOpportunityFilter.ALL,
  setOpportunities: () => {}
})


export const AccountOpportunityContextProvider  = ({ children }: {children: React.ReactNode}) => {
  const [opportunities, setOpportunities] = useState<AccountOpportunityFilterType>(AccountOpportunityFilter.ALL)

  return (
    <AccountOpportunityContext.Provider value={{ opportunities, setOpportunities }}>
      {children}
    </AccountOpportunityContext.Provider>
  )
}
